import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  min-height: 270px;
  margin: 0 10px;
  @media (max-height: 530px) {
    margin: 1px 4px;
  }
`;
export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const BaseHeadItem = styled.div`
  background-color: ${ColorSF2.paleBlue};
  padding: 10px;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;
export const Head1 = styled(BaseHeadItem)`
  flex: 0 0 105px;
  border-right: 1px solid ${ColorSF2.white};
`;
export const Head2 = styled(BaseHeadItem)`
  flex: 0 0 250px;
  border-right: 1px solid ${ColorSF2.white};
`;
export const Head3 = styled(BaseHeadItem)`
  flex: 1;
`;
export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const BodyItem = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${ColorSF2.white};
`;
export const Content1 = styled.div`
  flex: 0 0 105px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-right: 1px solid ${ColorSF2.mediumGray};
  background-color: ${ColorSF2.lightGray};
  padding: 10px;
  display: flex;
  align-items: center;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;
export const Content2 = styled.div`
  flex: 0 0 250px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  border-right: 1px solid ${ColorSF2.mediumGray};
  background-color: ${ColorSF2.white};
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;
export const Content3 = styled.div`
  flex: 1;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  background-color: ${ColorSF2.white};
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;

export const style = {
  contents: {
    marginTop: 2,
    backgroundColor: 'rgb(43, 47, 65)',
  },
  licenseTabs: {
    marginTop: 2,
    padding: '10px 0',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgb(43, 47, 65)',
  },
  licenseTab: {
    margin: '5px 0',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
  },
  input1: {
    width: 20,
    height: 20,
    textAlign: 'center',
  },
  input2: {
    width: 20,
    height: 20,
    textAlign: 'center',
  },
  inputId1: {
    width: 80,
    height: 20,
    textAlign: 'center',
  },
  inputId2: {
    width: 30,
    height: 20,
    marginRight: 5,
    textAlign: 'center',
  },
  inputId3: {
    width: 80,
    height: 20,
    textAlign: 'center',
  },
  inputDisable: {
    display: 'none',
  },
  group: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 2,
  },
  contractState: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: 2,
  },
  rowGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowGroup2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  plan: {
    flex: 1,
  },
  radio: {
    marginRight: 5,
  },
  center: {
    textAlign: 'center',
  },
  right: {
    textAlign: 'right',
    color: ColorSF2.black,
    fontSize: 8,
  },
  error: {
    backgroundColor: '#faa',
  },
  usageStateWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    wordBreak: 'break-all',
  },
  usageState: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    wordBreak: 'break-all',
    margin: '0 10px',
  },
  usageTitle: {
    width: 30,
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
